import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { ServicingService } from '../../../../services/servicing.service';
import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-courses-create',
  templateUrl: './courses-create.component.html',
  styleUrls: ['./courses-create.component.css']
})
export class CoursesCreateComponent implements OnInit {

  @Input() ID: string;
  @Input() langs: string;
  @Input() redirect: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;

  imageLink: any;
  redirect1: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    // this.FormBuild();
    this.getData();

    this.config();
    this.fileDesign();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };



  }


  config(): void {


    this.typeConfig = [
      { value: 'EQUIPMENT', text: 'VEHICLE' },
      { value: 'PLANT', text: 'PLANT' },
      { value: 'MACHINE', text: 'MACHINE' },
      { value: 'FIRE DISPENSER', text: 'FIRE DISPENSER' },
      { value: 'FIRST SERVICE DEVICE', text: 'FIRST SERVICE DEVICE' },
      { value: 'INDIVIDUAL PROTECTION DEVICE', text: 'INDIVIDUAL PROTECTION DEVICE' },
      { value: 'SAFETY EQUIPMENT', text: 'SAFETY EQUIPMENT' }
    ];



    // this.planConfig = [
    // { value: '7', text: '33 - e3' },
    // { value: '18', text: 'sarda - add' },
    // { value: '145', text: 'S 001 - test' }
    // ];


    this.emp_id = [
      { value: '886', text: 'demotest demotest' },
      { value: '885', text: 'dtesttest dtesttest' },
      { value: '523', text: 'PAOLO ROSSI' },
      { value: '739', text: 'Test 01' }
    ];


  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      service_type: ['', [Validators.required]],
      service_brand: ['', [Validators.required]],
      service_model: ['', [Validators.required]],
      service_no_plate: ['', [Validators.required]],
      service_disp: ['', [Validators.required]],
      service_fact: [''],
      service_doc: ['', [Validators.required]],
      service_location: ['', [Validators.required]],
      maintenance_plans: [''],
      // service_attach_exists: ['', [Validators.required]],
      emp_id: [''],
      service_recpon: ['Active'],
      //photo: ['', [Validators.required]],
      service_image_exists: this.formBuilder.array([this.newAttachment()]),
      service_attach_exists: this.formBuilder.array([this.newAttachment1()]),
      service_attach_uploaded: this.formBuilder.array([]),
      service_image_uploaded: this.formBuilder.array([]),
      //timetable_link_uploaded: this.formBuilder.array([]),
      // send_email: this.formBuilder.array([this.newEmail()]),
      id: '',
      action: 'update_service',
    });

    setTimeout(() => this.fileDesign(), 10);

    this.service_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

    this.service_image_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });


  }

  FormBuildUpdate(): void {
    // let emails = this.record.send_email.split(',');
    let simages = this.record.service_image.split(',');
    let images = this.record.service_attach.split(',');

    // console.log(simages); 
    // console.log(images);

    this.createForm.patchValue({
      service_type: this.record.service_type,
      service_brand: this.record.service_brand,
      service_model: this.record.service_model,
      service_no_plate: this.record.service_no_plate,
      service_disp: this.record.service_disp,
      service_fact: this.record.service_fact,
      service_doc: this.record.service_doc,
      service_location: this.record.service_location,
      maintenance_plans: this.record.maintenance_plans,

      // service_attach_exists: this.formBuilder.array([]),
      emp_id: this.record.emp_id,
      service_recpon: this.record.service_recpon,
      id: this.record.serviceId
    });

    // if(this.record.send_email) {
    // for (const email of emails) {
    // this.send_email().push(this.newEmail(email));
    // }
    // }
    // else
    // this.send_email().push(this.newEmail());

    // if(this.record.timetable_link) {
    // for (const image of images) {
    // this.timetable_link_uploaded().push(new FormControl(image.split('/').pop()));
    // }
    // }

    // console.log(this.record.serv_attlink);

    if (this.record.serv_attlink) {
      for (const image of images) {
        this.service_attach_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }

    if (this.record.serv_imglink) {
      for (const uimage of simages) {
        this.service_image_uploaded().push(new FormControl(uimage.split('/').pop()));
      }
    }



    setTimeout(() => this.fileDesign(), 10);

  }

  // send_email() : FormArray {
  // return this.createForm.get("send_email") as FormArray
  //  }

  // newEmail(data = ''): FormControl {
  // return new FormControl(data, Validators.email);
  // }

  // addEmail() {
  // this.send_email().push(this.newEmail());
  // }

  // removeEmail(i:number) {
  // this.send_email().removeAt(i);
  // }

  // emptyEmail() {
  // while (this.send_email().controls.length > 0) {
  // this.send_email().removeAt(0);
  // }
  // }

  service_attach_exists(): FormArray {
    return this.createForm.get('service_attach_exists') as FormArray;
  };

  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };

  newAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
    });
  }

  addAttachment(): void {
    this.service_attach_exists().push(this.newAttachment1());
  }

  removeAttachment(i: number) {
    this.service_attach_exists().removeAt(i);
  }

  // timetable_link_uploaded(): FormArray {
  // return this.createForm.get('timetable_link_uploaded') as FormArray;
  // };

  // removeAttachmentUploaded(i: number) {
  // this.timetable_link_uploaded().removeAt(i);
  // }

  service_attach_uploaded(): FormArray {
    return this.createForm.get('service_attach_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.service_attach_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }



  public selectAttachment(event: any, index) {

    this.createForm.value.service_image_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_image_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.service_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }


  onSubmit() {

    // console.log(this.createForm.value); return false;

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    //   console.log('test12'); return false;

    this.servicingService.update(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          if (this.redirect1 == "") {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.Servicing_List]);
              });
          }
          else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.SERVICING_VIEW+'/'+this.ID]);
          });
          }
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }



  // getData() {

  //   if (this.ID) 
  //   {
  //   this.mode = 'Edit';
  //   this.modalTitle = 'Edit Servicing';
  //   }
  //   else 
  //   {
  //   this.mode = 'Create';
  //   this.modalTitle = 'Create Servicing';
  //   }
  // }

  getData() {

    if (this.ID) {
      this.servicingService.edit(this.ID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }
          // this.lang = res.data.language;
          this.record = res.data.record;
          this.app_emp_id = res.data.record.emp_id1;
          this.app_maintenance_plans = res.data.record.app_maintenance_plans1;
          this.FormBuildUpdate();
        }
      );
      this.generalLang = this.langs;
      this.redirect1 = this.redirect;

      this.mode = 'Edit';
      this.modalTitle = this.generalLang.editServicingplan;
    }
    else {

      this.servicingService.getServicingList()
        .subscribe(
          (res) => {
            // this.lang = this.servicingService.createLang(res);
            this.app_emp_id = res.data.emp_id;
            this.app_maintenance_plans = res.data.app_maintenance_plans;
            console.log(this.app_maintenance_plans);
          }
        );


      this.generalLang = this.langs;
      this.redirect1 = '';

      this.mode = 'Create';
      this.modalTitle = this.generalLang.createServicing;


    }


    this.createFormErrorMsg = {
      'service_type': [{ type: 'required', message: this.generalLang.requiredField }],
      'service_brand': [{ type: 'required', message: this.generalLang.requiredField }],
      'service_model': [{ type: 'required', message: this.generalLang.requiredField }],
      'service_no_plate': [{ type: 'required', message: this.generalLang.requiredField }],
      'service_disp': [{ type: 'required', message: this.generalLang.requiredField }],
      // 'service_fact': [{ type: 'required', message: 'This field is Required' }],
      'service_doc': [{ type: 'required', message: this.generalLang.requiredField }],
      'service_location': [{ type: 'required', message: this.generalLang.requiredField }],
      // 'maintenance_plans': [{ type: 'required', message: 'This field is Required' }],
      // 'service_attach_exists': [{ type: 'required', message: 'This field is Required' }],
      // 'emp_id': [{ type: 'required', message: 'This field is Required' }],
      'service_recpon': [{ type: 'required', message: this.generalLang.requiredField }],

      'service_attach_exists': [
        { type: 'validExt', message: 'File format is not supported' }
      ],
      'service_image_exists': [
        { type: 'validExt', message: 'File format is not supported' }
      ],
      // 'send_email': [{ type: 'email', message: 'Please enter correct email format' }],
    }

    this.FormBuild();

  }

}
